export default __webpack_public_path__ + "static/ai_vertical_swe-d28713ea9989a64f37bd964f7b68a009.png";